import ErrorBell from '../../assets/img/notify/failed.svg';
import style from './style.module.scss';

export default function CustomToastError({ toastText }) {
  return (
    <div className={style.toast}>
      <img src={ErrorBell} alt="success info" />
      <div className={style.toastText}>
        <p>{toastText}</p>
      </div>
    </div>
  );
}
